import { render, staticRenderFns } from "./r-flash-ad-config-dialog.vue?vue&type=template&id=15a04312&scoped=true"
import script from "./r-flash-ad-config-dialog.vue?vue&type=script&lang=js"
export * from "./r-flash-ad-config-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-flash-ad-config-dialog.vue?vue&type=style&index=0&id=15a04312&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a04312",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a04312')) {
      api.createRecord('15a04312', component.options)
    } else {
      api.reload('15a04312', component.options)
    }
    module.hot.accept("./r-flash-ad-config-dialog.vue?vue&type=template&id=15a04312&scoped=true", function () {
      api.rerender('15a04312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/smart-offer/bundle-flash-ad/r-flash-ad-config-dialog.vue"
export default component.exports